import React, { useState } from "react";
import "./BoshSahifa.css";
import { BsPlusLg } from "react-icons/bs";
import FilterButton from "./FilterButton/FilterButton";
import arr from "../../Obj";
import Comment from "./Comment/Comment";
import RightFixed from "../RightFixed/RightFixed";

export default function BoshSahifa({
  setNewList,
  setMainArr,
  mainArr,
  saved,
  setSaved,
  newList,
  setSavedToList,
  savedToList,
  firstName,
}) {
  return (
    <div className="bosh-sahifa">
      <div className="bosh-container">
        <div className="plus">
          <div className="p-div">
            <BsPlusLg />
          </div>
          <p>Keep up with the latest in any topic</p>
        </div>
        <ul className="filter-btns">
          <FilterButton setMainArr={setMainArr} arr={arr} />
        </ul>

    <div className="fix-div"><RightFixed /></div>
  
        

        <ul className="main-info">
          {mainArr.map((obj) => {
            return (
              <Comment
              firstName={firstName}
                key={obj.id}
                obj={obj}
                setMainArr={setMainArr}
                setSaved={setSaved}
                saved={saved}
                mainArr={mainArr}
                setNewList={setNewList}
                newList={newList}
                savedToList={savedToList}
                setSavedToList={setSavedToList}
              />
            );
          })}
        </ul>
      </div>
    </div>
  );
}
